import { createContext, useContext, useState } from 'react';

const ApiTriggerContext = createContext();

export const ApiTriggerProvider = ({ children }) => {
  const [shouldTrigger, setShouldTrigger] = useState(false);

  const triggerSecondApi = () => setShouldTrigger(true);
  const resetTrigger = () => setShouldTrigger(false);

  return (
    <ApiTriggerContext.Provider value={{ shouldTrigger, triggerSecondApi, resetTrigger }}>
      {children}
    </ApiTriggerContext.Provider>
  );
};

export const useApiTrigger = () => useContext(ApiTriggerContext);
